import _asyncToGenerator from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6ada452c"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip-text"
}, "（预付金额根据进货价计算，利润返现等报表需进货价与销售价计算）", -1));

const _hoisted_2 = {
  class: "level-title"
};
const _hoisted_3 = {
  class: "price-row"
};
const _hoisted_4 = {
  class: "price-row"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定");

import { ref, watch, computed, reactive } from 'vue';
import { ElMessage } from 'element-plus';
import { updateTeamPrice } from '@/request'; // 需要添加这个API

export default {
  name: 'EditTeamPriceModal',
  props: {
    modelValue: Boolean,
    data: Object
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get: () => props.modelValue,
      set: val => emit('update:modelValue', val)
    });
    const form = reactive({
      priceList: []
    }); // 监听数据变化，初始化表单

    watch(() => props.data, newVal => {
      if (newVal) {
        var _newVal$supMerchandis;

        form.priceList = ((_newVal$supMerchandis = newVal.supMerchandisePriceList) === null || _newVal$supMerchandis === void 0 ? void 0 : _newVal$supMerchandis.map(item => _objectSpread(_objectSpread({}, item), {}, {
          branchId: String(item.branchId),
          supIncomePrice: Number(item.supIncomePrice),
          supSalePrice: Number(item.supSalePrice),
          supAveragePrice: Number(item.supAveragePrice)
        }))) || [];
      }
    }, {
      immediate: true
    });

    function save() {
      return _save.apply(this, arguments);
    }

    function _save() {
      _save = _asyncToGenerator(function* () {
        try {
          const res = yield updateTeamPrice(form.priceList);

          if (res.success) {
            ElMessage.success('保存成功');
            visible.value = false;
            emit('success');
            return;
          }

          ElMessage.error((res === null || res === void 0 ? void 0 : res.msg) || '保存失败');
        } catch (error) {
          ElMessage.error((error === null || error === void 0 ? void 0 : error.message) || '保存失败');
          console.error(error);
        }
      });
      return _save.apply(this, arguments);
    }

    return (_ctx, _cache) => {
      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "团队价格编辑",
        width: "700px",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_1, _createVNode(_component_el_form, {
          "label-width": "120px"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.priceList, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "price-item"
            }, [_createElementVNode("div", _hoisted_2, _toDisplayString(item.areaLevelName), 1), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form_item, {
              label: "业务员进货价"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: item.supIncomePrice,
                "onUpdate:modelValue": $event => item.supIncomePrice = $event,
                precision: 2,
                step: 0.1,
                min: 0
              }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])]),
              _: 2
            }, 1024), _createVNode(_component_el_form_item, {
              label: "负责人进货价格"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: item.supSalePrice,
                "onUpdate:modelValue": $event => item.supSalePrice = $event,
                precision: 2,
                step: 0.1,
                min: 0
              }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])]),
              _: 2
            }, 1024)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form_item, {
              label: "活动均摊价(最低)"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                modelValue: item.supAveragePrice,
                "onUpdate:modelValue": $event => item.supAveragePrice = $event,
                precision: 2,
                step: 0.1,
                min: 0
              }, null, 8, ["modelValue", "onUpdate:modelValue", "step"])]),
              _: 2
            }, 1024)])]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};